// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3Y_wD","right":"styles_right__1m6vO"};